window.addEventListener('load', () => {
  
    setTimeout(() => {
      const storeBadges = Array.from(document.querySelectorAll(".store-badges .badge"));
      const discountBadgeId = "gid://shopify/Metaobject/93092053184";

      // Check if current page is best-sellers
      const isBestSellersPage = window.location.pathname.includes('best-sellers') || 
                                 window.location.pathname.includes('best_sellers') ||
                                 document.body.classList.contains('best-sellers');

      // Loop through each Nosto product element
      document.querySelectorAll("[data-product-badges]").forEach((nostoEl) => {

        nostoEl.style.paddingTop = '15px'
        const nostoImagesEl = nostoEl.querySelector('.nosto-product-images');
        const nostoListParent = nostoEl.closest('.nosto-list');
        if (nostoListParent) {
          nostoListParent.style.marginTop = '-15px';
        }

        // Parse the data-product-badges array
        let productBadgeIds;
        try {
          let raw = nostoEl.getAttribute("data-product-badges").replace(/&quot;/g, '"');

          // If it doesn't start with [ … ], wrap it into an array
          if (!raw.trim().startsWith("[")) {
            raw = `[${raw}]`;
          }

          productBadgeIds = JSON.parse(raw);
        } catch (e) {
          console.warn("Failed to parse data-product-badges", e);
          productBadgeIds = [];
        }

        // Check if product is discounted by looking for both new and old prices
        const newPriceEl = nostoEl.querySelector('.nosto-newprice');
        const oldPriceEl = nostoEl.querySelector('.nosto-oldprice');
        const isDiscounted = newPriceEl && oldPriceEl;

        // Collect all badges to add (including discount badge if applicable)
        const badgesToAdd = [];

        // Loop through productBadgeIds and find matching badges
        productBadgeIds.forEach((prodId) => {
          const cleanId = prodId.replace(/^"|"$/g, ''); // remove leading/trailing quotes
          console.log("tova raboti tuk");

          const matchingBadge = storeBadges.find(
            (badge) => badge.getAttribute("data-badge-id") === cleanId
          );
          if (matchingBadge) {
            badgesToAdd.push(matchingBadge);
          }
        });

        // Add discount badge if product is discounted AND not on best-sellers page
        if (isDiscounted && !isBestSellersPage) {
          const discountBadge = storeBadges.find(
            (badge) => badge.getAttribute("data-badge-id") === discountBadgeId
          );
          if (discountBadge) {
            badgesToAdd.push(discountBadge);
          }
        }

        // Filter badges to keep only highest z-index per position
        const positionMap = new Map();
        
        badgesToAdd.forEach((badge) => {
          // Find position classes (q-1-p-1, q-1-p-2, etc.)
          const classList = Array.from(badge.classList);
          const positionClass = classList.find(cls => cls.match(/^q-\d+-p-\d+$/));
          
          if (positionClass) {
            const zIndex = parseInt(window.getComputedStyle(badge).zIndex) || 0;
            
            if (!positionMap.has(positionClass) || positionMap.get(positionClass).zIndex < zIndex) {
              positionMap.set(positionClass, { badge, zIndex });
            }
          } else {
            // If no position class, add it anyway
            const uniqueKey = `no-position-${Math.random()}`;
            positionMap.set(uniqueKey, { badge, zIndex: 0 });
          }
        });

        // Append the filtered badges
        positionMap.forEach(({ badge }) => {
          const badgeClone = badge.cloneNode(true);
          nostoImagesEl.appendChild(badgeClone);
        });

      });
    }, 2000);
  });